import { AuthenticationService } from 'src/app/_services/authentication.service';
import { Injectable } from '@angular/core'
import {
  HttpEvent,
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http'
import { Observable, throwError, timer } from 'rxjs'
import { retry, catchError, filter, map, mergeMap, retryWhen, finalize } from 'rxjs/operators'
import { Router } from '@angular/router'
@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router, private authService: AuthenticationService) { }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      retryWhen(genericRetryStrategy({
        scalingDuration: 1000,
        excludedStatusCodes: [400, 500, 422]
      })),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 422) {
          localStorage.removeItem('currentUser')
          this.authService.logout()
        } else {
          return throwError(error)
        }
      })
    )
  }
}


export const genericRetryStrategy = ({
  maxRetryAttempts = 1,
  scalingDuration = 1000,
  excludedStatusCodes = []
}: {
  maxRetryAttempts?: number,
  scalingDuration?: number,
  excludedStatusCodes?: number[]
} = {}) => (attempts: Observable<any>) => {
  return attempts.pipe(
    mergeMap((error, i) => {
      const retryAttempt = i + 1;
      // if maximum number of retries have been met
      // or response is a status code we don't wish to retry, throw error
      if (
        retryAttempt > maxRetryAttempts ||
        excludedStatusCodes.find(e => e === error.status)
      ) {
        return throwError(error);
      }
      console.log(
        `Attempt ${retryAttempt}: retrying in ${retryAttempt *
        scalingDuration}ms`
      );
      // retry after 1s, 2s, etc...
      return timer(retryAttempt * scalingDuration);
    }),
    finalize(() => console.log('We are done!'))
  );
};
